import { render, staticRenderFns } from "./BlockListTextMediaCustom.vue?vue&type=template&id=2869eb78&"
import script from "./BlockListTextMediaCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListTextMediaCustom.vue?vue&type=script&lang=js&"
import style0 from "./BlockListTextMediaCustom.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports